
import * as React from 'react';
import * as ReactDOM from 'react-dom/client';
import { Navigate, RouterProvider } from 'react-router-dom';
import { Provider } from 'react-redux';
import { AuthProvider, AuthProviderProps } from 'oidc-react';
import { PrimeReactProvider } from 'primereact/api';
import { oidcConfig } from '../services/authentication';
import { store } from '../store';
import Root from '../routes/root';
import AuthCallback from '../pages/auth/AuthCallback';
import Dashboard from '../pages/dashboard';

import '../styles/root.scss'
import primeStyles from '../styles/prime';
import 'primeicons/primeicons.css';
import UploadPage from '../pages/Upload';
import GroupsIndex from '../pages/Group/Index';
import GroupDetail from '../pages/Group/GroupDetail';
import UnauthorizedPage from '../pages/UnauthorizedPage';
import { UserRole } from '../store/auth';
import ProtectedRoute from '../components/auth/ProtectedRoute';
import { authIsEnabled } from '../utils/auth';
import { sentryCreateBrowserRouter } from '../sentry';

function main () {
    const router = sentryCreateBrowserRouter([
        {
            path: '/',
            element: <Root />,
            children: [
                {
                    path: '',
                    element: (<Navigate to="/groups" replace />),
                },
                {
                    path: '*',
                    element: (<Navigate to="/groups" replace />),
                },
                {
                    path: 'signin',
                    element: <AuthCallback />
                },
                {
                    path: 'groups',
                    element: <GroupsIndex />,
                    children: [
                        {
                            path: '',
                            element: <Dashboard />
                        },
                        {
                            path: ':timePeriodDate/:policyNumber',
                            element: <GroupDetail />
                        },
                    ]
                },
                {
                    path: 'upload',
                    element: (
                        <ProtectedRoute role={UserRole.ACTUARY}>
                            <UploadPage />
                        </ProtectedRoute>
                    ),
                }
            ],
        },
        {
            path: 'unauthorized',
            element: <UnauthorizedPage />,
        }
    ]);

    return ReactDOM.createRoot(document.getElementById('app')!).render(
        <Provider store={store}>
            {authIsEnabled() && (
                <AuthProvider {...oidcConfig}>
                    <PrimeReactProvider value={{ unstyled: true, pt: primeStyles }}>
                        <RouterProvider router={router} />      
                    </PrimeReactProvider>
                </AuthProvider>
            )}
            {!authIsEnabled() && (
                <PrimeReactProvider value={{ unstyled: true, pt: primeStyles }}>
                    <RouterProvider router={router} />      
                </PrimeReactProvider>
            )}
        </Provider>
    );
};

export { main }